export function prepareArrayPropertyForFormData(value: any[] | null | undefined) {
  if (value && value?.length > 0) {
    return value;
  }

  return undefined;
}
